import {Injectable} from '@angular/core';
import {CurriculumVitae} from "../domain/curriculumVitae";
import {AuthService} from "../../core/security/auth.service";
import {ProfileService} from "./profile.service";
import {ConfirmationService} from "primeng/components/common/api";
import {CurriculumVitaeService} from "./curriculum-vitae.service";
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Observable} from 'rxjs/Observable';
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

@Injectable()
export class CurriculumStoreService {

    private subjectCV: BehaviorSubject<CurriculumVitae> = new BehaviorSubject<CurriculumVitae>(null);

    // curriculumVitae: Observable<CurriculumVitae>;

    constructor(private authService: AuthService,
                private cvService: CurriculumVitaeService,
                private confirmationService: ConfirmationService) {
        this.authService.user
            .switchMap(user => this.cvService.getByUserId(user.id))
            .catch(e => {
                if (e.status === 404) {
                    console.log("404");
                    /**
                    return this.confirmCVCreate()
                        .filter(b => b)
                        .switchMap(b => Observable.of(new CurriculumVitae()));
                    */
                    return Observable.of(new CurriculumVitae());
                } else return Observable.throw(e);
            })
             //.do(p => console.log("cv.next-profile: " + p.id))
            .subscribe(cv => this.subjectCV.next(cv));
    }

    getCurriculumVitae(): Observable<CurriculumVitae> {
        return this.subjectCV.asObservable().filter(p => p != null);
    }

    save(cv: CurriculumVitae): Observable<CurriculumVitae> {
        if (!cv.id)
            return this.cvService.create(cv).do(cv => this.subjectCV.next(cv));
        else
            return this.cvService.update(cv).do(cv => this.subjectCV.next(cv));
    }

    confirmCVCreate(): Observable<boolean> {
        var confirm = new Subject<boolean>()
        this.confirmationService.confirm({
            header: 'Crear un curriculum vitae',
            message: 'Usted no posee un curriculum vitae ¿desea crearlo ahora?',
            icon: 'fa ui-icon-add-circle-outline',
            accept: () => {
                confirm.next(true);
                confirm.complete();
            },
            reject: () => {
                confirm.next(false);
                confirm.complete();
            }
        })
        return confirm.asObservable()
    }

}



// WEBPACK FOOTER //
// ./src/app/profile/service/curriculum-store.service.ts